import {SupportedLocales} from '#types/locale.js';

export const mediaBriefsLanguage = {
  [SupportedLocales.EN]: {
    errors: {
      maxBriefsExceeded: (max: number) => `Maximum of ${max} files allowed.`,
      extractFailed: 'Failed to extract file:',
      uploadFailed: 'Failed to upload file. Please try again.',
    },
    uploader: {
      multipleBriefsSelected: (count: number) =>
        `${count} ${count === 1 ? 'file' : 'files'} selected`,
      uploading: 'Uploading…',
      addMediaBrief: '@ Add File',
      removeBrief: (filename: string) => `Remove ${filename}`,
      uploadFile: 'Upload File',
      maxBriefsReached: (max: number) => `Maximum of ${max} files reached`,
      supportedFormats: (max: number) => `Supports: .txt, .csv (max ${max})`,
    },
  },
  [SupportedLocales.ES]: {
    errors: {
      maxBriefsExceeded: (max: number) =>
        `Se permite un máximo de ${max} archivos.`,
      extractFailed: 'Error al extraer el archivo:',
      uploadFailed:
        'Error al cargar el archivo. Por favor, inténtalo de nuevo.',
    },
    uploader: {
      multipleBriefsSelected: (count: number) =>
        `${count} ${count === 1 ? 'archivo seleccionado' : 'archivos seleccionados'}`,
      uploading: 'Cargando…',
      addMediaBrief: '@ Agregar archivo',
      removeBrief: (filename: string) => `Eliminar ${filename}`,
      uploadFile: 'Subir archivo',
      maxBriefsReached: (max: number) =>
        `Se alcanzó el máximo de ${max} archivos`,
      supportedFormats: (max: number) =>
        `Formatos soportados: .txt, .csv (máx ${max})`,
    },
  },
};
